import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Click() {
  const navigate = useNavigate();
  const [isHoveredFirst, setIsHoveredFirst] = useState(false);
  const [isHoveredSecond, setIsHoveredSecond] = useState(false);
  const [isHoveredThird, setIsHoveredThird] = useState(false);
  const [isHoveredFourth, setIsHoveredFourth] = useState(false);
  const [isClickedFirst, setIsClickedFirst] = useState(false);
  const [isClickedSecond, setIsClickedSecond] = useState(false);
  const [isClickedThird, setIsClickedThird] = useState(false);
  const [isClickedFourth, setIsClickedFourth] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const imageRef = useRef(null);
  const secondImageRef = useRef(null);
  const thirdImageRef = useRef(null);
  const fourthImageRef = useRef(null);
  const timeoutRefs = useRef([]);

  useEffect(() => {
    const checkScreenResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkScreenResize();
    window.addEventListener("resize", checkScreenResize);
    return () => window.removeEventListener("resize", checkScreenResize);
  }, []);

useEffect(() => {
  // Clear any existing timeouts first
  timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
  timeoutRefs.current = [];

  const startTimeout = setTimeout(() => {
    setIsHoveredThird(true); // Start with Kulla 3

    const thirdTimeout = setTimeout(() => {
      setIsHoveredThird(false);
      setIsHoveredFourth(true); // Then Kulla 4

      const fourthTimeout = setTimeout(() => {
        setIsHoveredFourth(false);
        setIsHoveredFirst(true); // Then Kulla 5

    const firstTimeout = setTimeout(() => {
      setIsHoveredFirst(false);
          setIsHoveredSecond(true); // Finally Kulla 6

      const secondTimeout = setTimeout(() => {
        setIsHoveredSecond(false);
          }, 600); // Kulla 6 stays visible

          timeoutRefs.current.push(secondTimeout);
        }, 600); // Kulla 5 stays visible

        timeoutRefs.current.push(firstTimeout);
      }, 600); // Kulla 4 stays visible

      timeoutRefs.current.push(fourthTimeout);
    }, 600); // Kulla 3 stays visible

    timeoutRefs.current.push(thirdTimeout);
  }, 300); // Initial delay before animation starts

  timeoutRefs.current.push(startTimeout);

  // Cleanup all timeouts
  return () => {
    timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
    timeoutRefs.current = [];
  };
}, []);



  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideFirst = imageRef.current && imageRef.current.contains(event.target);
      const clickedInsideSecond = secondImageRef.current && secondImageRef.current.contains(event.target);
      const clickedInsideThird = thirdImageRef.current && thirdImageRef.current.contains(event.target);
      const clickedInsideFourth = fourthImageRef.current && fourthImageRef.current.contains(event.target);

      if (!clickedInsideFirst && !clickedInsideSecond && !clickedInsideThird && !clickedInsideFourth) {
        setIsHoveredFirst(false);
        setIsHoveredSecond(false);
        setIsHoveredThird(false);
        setIsHoveredFourth(false);
        setIsClickedFirst(false);
        setIsClickedSecond(false);
        setIsClickedThird(false);
        setIsClickedFourth(false);
      }
    };

    if (isMobile && (isClickedFirst || isClickedSecond || isClickedThird || isClickedFourth)) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClickedFirst, isClickedSecond, isClickedThird, isClickedFourth]);

  const handleClickFirst = () => {
    if (isMobile) {
      // Stop animation when clicking
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
      timeoutRefs.current = [];
      
      if (!isClickedFirst) {
        setIsHoveredFirst(true);
        setIsClickedFirst(true);
        // Hide all other kullat
        setIsHoveredSecond(false);
        setIsHoveredThird(false);
        setIsHoveredFourth(false);
        setIsClickedSecond(false);
        setIsClickedThird(false);
        setIsClickedFourth(false);
      } else {
        navigate("/click-floor");
      }
    } else {
      window.location.href = "/click-floor";
    }
  };

  const handleClickSecond = () => {
    if (isMobile) {
      // Stop animation when clicking
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
      timeoutRefs.current = [];
      
      if (!isClickedSecond) {
        setIsHoveredSecond(true);
        setIsClickedSecond(true);
        // Hide all other kullat
        setIsHoveredFirst(false);
        setIsHoveredThird(false);
        setIsHoveredFourth(false);
        setIsClickedFirst(false);
        setIsClickedThird(false);
        setIsClickedFourth(false);
      } else {
        navigate("/click-floor");
      }
    } else {
      window.location.href = "/click-floor";
    }
  };

  const handleClickThird = () => {
    if (isMobile) {
      // Stop animation when clicking
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
      timeoutRefs.current = [];
      
      if (!isClickedThird) {
        setIsHoveredThird(true);
        setIsClickedThird(true);
        // Hide all other kullat
        setIsHoveredFirst(false);
        setIsHoveredSecond(false);
        setIsHoveredFourth(false);
        setIsClickedFirst(false);
        setIsClickedSecond(false);
        setIsClickedFourth(false);
      } else {
        navigate("/click-floor-34");
      }
    } else {
      window.location.href = "/click-floor-34";
    }
  };

  const handleClickFourth = () => {
    if (isMobile) {
      // Stop animation when clicking
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
      timeoutRefs.current = [];
      
      if (!isClickedFourth) {
        setIsHoveredFourth(true);
        setIsClickedFourth(true);
        // Hide all other kullat
        setIsHoveredFirst(false);
        setIsHoveredSecond(false);
        setIsHoveredThird(false);
        setIsClickedFirst(false);
        setIsClickedSecond(false);
        setIsClickedThird(false);
      } else {
        navigate("/click-floor-34");
      }
    } else {
      window.location.href = "/click-floor-34";
    }
  };

  return (
    <div className="w-full">
      <div className="w-full relative lg:top-[-5vw]">
        <img
          loading="lazy"
          src="/images/click/clean-images/click-kullat-far.jpg"
          className="relative right-0 w-full h-auto"
          alt="Distant view of Kulla towers"
        />

        {/* Kulla 3 with Hover Text */}
        <div className="absolute left-[30.55%] top-[20.8%] w-[18.6%] group">
  <img
    ref={thirdImageRef}
    onMouseEnter={() => !isMobile && setIsHoveredThird(true)}
    onMouseLeave={() => !isMobile && setIsHoveredThird(false)}
    src="/images/click/clickable-images/Kullat/Kulla3-Green.png"
    alt="Kulla 3"
    className={`w-full cursor-pointer transition-opacity duration-300 ${
      isHoveredThird || isClickedThird ? "opacity-100" : "opacity-0"
    }`}
    onClick={handleClickThird}
    style={{ pointerEvents: "auto", transformOrigin: "bottom" }}
  />

<div className="absolute right-[18.8vw] lg:right-[18.8vw] top-[13vw]
                w-fit whitespace-nowrap
                transform -translate-y-1/2
                bg-[#192929] montserrat font-medium
                text-white text-xs md:text-base
                px-2 lg:px-4 py-2 lg:py-3
                opacity-0 transition-opacity duration-300
                group-hover:opacity-100">
  <p>Kulla 3</p>
</div>
</div>
        {/* Kulla 4 with Hover Text */}
        <div className="absolute w-[22vw] right-[34.4vw] md:right-[35.7vw] lg:right-[36.4vw] top-[17.3vw] group">
          <img
            ref={fourthImageRef}
            onMouseEnter={() => !isMobile && setIsHoveredFourth(true)}
            onMouseLeave={() => !isMobile && setIsHoveredFourth(false)}
            src="/images/click/clickable-images/Kullat/Kulla4-Green.png"
            alt="Kulla 4"
            className={`cursor-pointer transition-opacity lg:duration-300 ${
              isHoveredFourth || isClickedFourth ? "opacity-100" : "opacity-0"
            }`}
            onClick={handleClickFourth}
            onError={(e) => {
              console.error('Error loading Kulla4-Green.png:', e.target.src);
            }}
            style={{ pointerEvents: 'auto' }}
          />
          <div className="absolute right-[20vw] lg:right-[20vw] top-[13vw] w-fit whitespace-nowrap transform -translate-y-1/2 bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <p>Kulla 4</p>
          </div>
        </div>

        {/* Kulla 5 with Hover Text */}
        <div className="absolute w-[19vw] right-[24vw] md:right-[24.2vw] lg:right-[25vw] top-[23.5vw] group">
          <img
            ref={secondImageRef}
            onMouseEnter={() => !isMobile && setIsHoveredFirst(true)}
            onMouseLeave={() => !isMobile && setIsHoveredFirst(false)}
            src="/images/click/clickable-images/Kullat/Kulla5-Green.png"
            alt="Kulla 5"
            className={`cursor-pointer transition-opacity lg:duration-300 ${
              isHoveredFirst || isClickedFirst ? "opacity-100" : "opacity-0"
            }`}
            onClick={handleClickFirst}
            onError={(e) => {
              console.error('Error loading Kulla5-Green.png:', e.target.src);
            }}
            style={{ pointerEvents: 'auto' }}
          />
          <div className="absolute right-[20vw] lg:right-[20vw] top-[13vw] w-fit whitespace-nowrap transform -translate-y-1/2 bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100 pointer-events-none">
            <p>Kulla 5</p>
          </div>
        </div>

        {/* Kulla 6 with Hover Text */}
        <div className="absolute w-[24vw] right-[3.8vw]  md:right-[4vw] lg:right-[4.22vw] top-[24.7vw] lg:top-[25vw] group">
          <img
            ref={imageRef}
            onMouseEnter={() => !isMobile && setIsHoveredSecond(true)}
            onMouseLeave={() => !isMobile && setIsHoveredSecond(false)}
            src="/images/click/clickable-images/Kullat/Kulla6-Green.png"
            alt="Kulla 6"
            className={`cursor-pointer transition-opacity lg:duration-300 ${
              isHoveredSecond || isClickedSecond ? "opacity-100" : "opacity-0"
            }`}
            onClick={handleClickSecond}
            onError={(e) => {
              console.error('Error loading Kulla6-Green.png:', e.target.src);
            }}
            style={{ pointerEvents: 'auto' }}
          />
          <div className="absolute right-[-2.5vw] w-fit whitespace-nowrap lg:right-[0.1vw] top-[10vw] transform -translate-y-1/2 bg-[#192929] montserrat font-medium text-white text-xs md:text-base px-2 lg:px-4 py-2 lg:py-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            Kulla 6
          </div>
        </div>
      </div>
    </div>
  );
}

export default Click;
